import { render, staticRenderFns } from "./CorbeillesCampagne.vue?vue&type=template&id=2db39146"
import script from "./CorbeillesCampagne.vue?vue&type=script&lang=js"
export * from "./CorbeillesCampagne.vue?vue&type=script&lang=js"
import style0 from "./CorbeillesCampagne.vue?vue&type=style&index=0&id=2db39146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports